import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import React, { useEffect } from 'react';
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Form, Modal } from "antd";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";

type AddExamCourseModalModalProps = {
  onCancel: () => void;
  open: boolean;
  onFinish: (values: any) => void;
  courseOptions: any[];
  sectionOptions: any[];
  sequenceOptions: any[];
  form: any;
};

const AddExamCourseModal: React.FC<AddExamCourseModalModalProps> = ({
  onCancel,
  open,
  onFinish,
  courseOptions,
  sectionOptions,
  sequenceOptions,
  form,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);
  return (
    <Modal
      className="add-exam-course-modal"
      title={t("Thêm đề vào khóa học", "Thêm đề vào khóa học")}
      open={open}
      onOk={() => form.submit()}
      onCancel={onCancel}
      okButtonProps={{
        icon: <PlusOutlined />,
      }}
      okText={t("Thêm", "Thêm")}
      cancelButtonProps={{
        icon: <CloseOutlined />,
      }}
      cancelText={t("Hủy", "Hủy")}
    >
      <Form layout={"vertical"} form={form} onFinish={onFinish}>
        <Form.Item
          name="course"
          label={t("Chọn khóa học", "Chọn khóa học")}
          rules={[
            {
              required: true,
              message: t("Vui lòng chọn khóa học", "Vui lòng chọn khóa học"),
            },
          ]}
        >
          <FormItemDropdown
            options={courseOptions}
            allowClear={true}
            placeholder={t("Chọn khóa học", "Chọn khóa học")}
          />
        </Form.Item>
        <Form.Item
          name="section"
          label={t("Chọn Chương", "Chọn Chương")}
          rules={[
            {
              required: true,
              message: t("Vui lòng chọn Chương", "Vui lòng chọn Chương"),
            },
          ]}
        >
          <FormItemDropdown
            options={sectionOptions}
            allowClear={true}
            placeholder={t("Chọn Chương", "Chọn Chương")}
          />
        </Form.Item>
        <Form.Item
          name="sequence"
          label={t("Chọn Bài giảng", "Chọn Bài giảng")}
          rules={[
            {
              required: true,
              message: t("Vui lòng chọn Bài giảng", "Vui lòng chọn Bài giảng"),
            },
          ]}
        >
          <FormItemDropdown
            options={sequenceOptions}
            allowClear={true}
            placeholder={t("Chọn Bài giảng", "Chọn Bài giảng")}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddExamCourseModal;